import request from '@/utils/request'
import axios from 'axios'

// OCR（限制次数）
export const uploadLimitOCR = (data) => {
  return request({
    url: '/api/manage/product/ocr/limit/ocr',
    method: 'post',
		data
  })
}

// 获取银行列表
export const getBankList = () => {
  return request({
    url: '/api/manage/config/bank',
    method: 'get'
  })
}

// 企业信息提交,,弃用
export const submitEntForm = (data) => {
  return request({
    url: '/api/manage/labor/invite',
    method: 'post',
		data
  })
}

// 企业认证提交
export const submit = (data) => {
  return request({
    url: '/api/manage/labor/verify/apply',
    method: 'post',
    data
  })
}

// 企业认证详情
export const getVerifyInfo = () => {
  return request({
    url: '/api/manage/labor/verify/info',
    method: 'get'
  })
}

// 企业认证详情
export const getVerifyInfoById = (id) => {
  return request({
    url: `/api/manage/labor/verify/info/${id}`,
    method: 'get'
  })
}

// 获取商务列表
export const getBusinessList = (params) => {
  return request({
    url: '/api/manage/business/info/nonToken/list',
    method: 'get',
    params
  })
}

export default {
	uploadLimitOCR,
	getBankList,
	submitEntForm,
  submit,
  getBusinessList,
  getVerifyInfo,
  getVerifyInfoById
}
